<template>
    <div class="row">
        <div class="col signal-column" id="resize1">
            <div v-for="signalBot in signalbots" :class="{card: true, active: signalBot.id === currentBot.id}" @click="changeBot(signalBot)" style="cursor: pointer;">
                <div class="card-body">
                    {{ signalBot.name }}
                </div>
            </div>
        </div>
        <div class="col outer-container" id="resize2">
            <div class="header">
                <div style="width: 95%;">
                    <autocomplete
                        :search="searchPairs"
                        @submit="onSubmitPair"
                    ></autocomplete>
                </div>
            </div>
            <div style="height: 100%; padding-top: 50px;">
                <div class="scroll-container" ref="signalsBlock">
                    <div v-for="signal in currentSignals" :class="{card: true, active: signal.pair === currentPair}" @click="changePair(signal.pair)" style="cursor: pointer;">
                        <div class="card-body" v-html="signal.message_string"></div>
                        <div class="card-footer">{{ moment(signal.created_at).format('YYYY-MM-DD HH:mm') }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col signal-column" ref="pairBlock" id="resize3">
            <div v-for="signal in pairSignals" class="card">
                <div class="card-body" v-html="signal.message_string"></div>
                <div class="card-footer">{{ moment(signal.created_at).format('YYYY-MM-DD HH:mm') }}</div>
            </div>
        </div>
        <div class="col signal-column" id="resize4">
            <div class="row">
                <div class="col-4">
                    <div>
                        <label>Показывать только + цены</label>
                        <input type="checkbox" v-model="isFilterPriceUp" :value="true"/>
                    </div>
                    <div>
                        <label>Показывать только + OI</label>
                        <input type="checkbox" v-model="isFilterOiUp" :value="true"/>
                    </div>
                </div>
                <div class="col-3">
                    <div v-for="service in services" :key="service">
                        <label>{{ service }}</label>
                        <input type="checkbox" v-model="selectedServices" :value="service"/>
                    </div>
                </div>
                <div class="col-3">
                    <div v-for="signalBot in signalBots" :key="signalBot.id" v-if="signalBot.is_chart">
                        <label>{{ signalBot.name }}</label>
                        <input type="checkbox" v-model="selectedBots" :value="signalBot"/>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-left: 10px;">
                <div v-for="interval in klineIntervals" :key="interval" style="margin-right: 20px;">
                    <label>{{ interval }}</label>
                    <input type="checkbox" v-model="selectedIntervals" :value="interval" @change="toggleChart($event.target.value, $event.target.checked)"/>
                </div>
            </div>

            <div v-for="interval in selectedIntervals">
                <br>
                <h3>{{ interval }}</h3>
                <trading-vue
                    :width="width"
                    :height="height"
                    :data="charts[interval]"
                    :color-back="colors.colorBack"
                    :color-grid="colors.colorGrid"
                    :color-text="colors.colorText"

                    :colorCandleUp="colors.colorCandleUp"
                    :colorCandleDw="colors.colorCandleDw"
                    :overlays="overlays"
                    :title-txt="''"
                >
                </trading-vue>
            </div>
        </div>
    </div>
</template>

<style>
    .active {
        background-color: #0b5ed7;
        color: white;
    }

    .signal-column {
        height: 90vh;
        overflow-y: auto;
    }

    .scroll-container {
        height: 100%;
        overflow-y: scroll;
    }
    .outer-container {
        position: relative;
        height: 90vh;
    }
    .header {
        position: absolute;
        width: 100%;
        z-index: 2;
    }

    .split {-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;overflow-y: auto;overflow-x: hidden;}
    .gutter {background-color: transparent;background-repeat: no-repeat;background-position: 50%;}
    .gutter.gutter-horizontal {cursor: col-resize;background-image:  url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg=='); }
    .gutter.gutter-vertical {cursor: row-resize;background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII='); }
    .split.split-horizontal, .gutter.gutter-horizontal { height: 90vh;float: left;}
</style>

<script>
    import TradingVue from 'trading-vue-js'
    import LongShortTrades from './overlays/LongShortTrades.vue'
    import moment from 'moment'
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import '@trevoreyre/autocomplete-vue/dist/style.css'

    export default {
        components: { TradingVue, Autocomplete },
        props: {
            signalbots: {
                type: Array,
                required: true
            },
        },
        data() {
            return {
                moment: moment,
                signalBots: [],
                currentBot: {
                    id: 0,
                    signals: [],
                },
                filterPair: '',
                currentPair: '',
                charts: {
                    '1m': {},
                    '3m': {},
                    '5m': {},
                    '15m': {},
                    '30m': {},
                    '1h': {},
                },
                colors: {
                    colorBack: '#1D1C23',
                    colorGrid: '#1D1C23',
                    colorText: '#a6a6a6',
                    colorCandleUp: '#29ac5e',
                    colorCandleDw: '#fc4b51',
                },
                overlays: [LongShortTrades],
                width: window.innerWidth * 0.4,
                height:  window.innerHeight * 0.4,
                klineIntervals: [
                    '1m',
                    '3m',
                    '5m',
                    '15m',
                    '30m',
                    '1h',
                ],
                services: [
                    'binance',
                    'bybit',
                    'coinglass',
                ],
                selectedServices: [],
                isFilterPriceUp: false,
                isFilterOiUp: false,
                selectedBots: [],
                selectedIntervals: ['1m'],
            }
        },
        watch: {
            'selectedServices': {
                handler: function () {
                    if (this.currentPair) {
                        this.generateChart();
                    }
                },
            },
            'selectedBots': {
                handler: function () {
                    if (this.currentPair) {
                        this.generateChart();
                    }
                },
            },
            'isFilterPriceUp': {
                handler: function () {
                    if (this.currentPair) {
                        this.generateChart();
                    }
                },
            },
            'isFilterOiUp': {
                handler: function () {
                    if (this.currentPair) {
                        this.generateChart();
                    }
                },
            },
        },
        computed: {
            pairSignals() {
                let pairSymbols = [];
                this.signalBots.forEach((signalBot) => {
                    pairSymbols = pairSymbols.concat(
                        signalBot.signals.filter((signal) => {
                            signal.bot_key = signalBot.key;

                            let isOk = signal.pair === this.currentPair && this.selectedServices.includes(signal.service);
                            const signalData = JSON.parse(signal.data);
                            if (isOk && this.isFilterPriceUp) {
                                isOk = signalData.is_price_up;
                            }
                            if (isOk && this.isFilterOiUp) {
                                isOk = signalData.is_oi_up;
                            }

                            return isOk;
                        })
                    );
                });
                return pairSymbols.sort((a, b) => a.created_at.localeCompare(b.created_at));;
            },
            currentPairs() {
                let pairs = [...new Set(this.currentBot.signals.map(item => item.pair))].sort();
                pairs.unshift('');
                return pairs;
            },
            currentSignals() {
                if (this.currentBot) {
                    return this.currentBot.signals.filter((signal) => {
                        return this.filterPair === '' || this.filterPair === signal.pair;
                    });
                }
                return [];
            },
        },
        mounted() {
            console.log('Component mounted.')

            this.signalBots = this.signalbots;
            this.changeBot(this.signalbots[0]);

            this.selectedServices = this.services;
            this.selectedBots = this.signalBots.filter((signalBot) => {
                return signalBot.is_chart;
            });

            /*document.querySelectorAll('.trading-vue-legend').forEach(function(el) {
                el.style.display = 'none';
            });

            document.querySelectorAll('.trading-vue-botbar').forEach(function(el) {
                el.style.display = 'none';
            });

            if (!this.strategyId) {
                document.querySelectorAll('.trading-vue-sidebar-0').forEach(function(el) {
                    el.style.display = 'none';
                });

                document.querySelectorAll('#trading-vue-js').forEach(function(el) {
                    el.style.marginTop = '15px';
                    el.style.position = 'relative';
                });
            }*/
            window.addEventListener('resize', this.onResize);

            Split(["#resize1", "#resize2", "#resize3", "#resize4"], {
                elementStyle: function (dimension, size, gutterSize) {
                    $(window).trigger('resize'); // Optional
                    return {'flex-basis': 'calc(' + size + '% - ' + gutterSize + 'px)'}
                },
                gutterStyle: function (dimension, gutterSize) { return {'flex-basis':  gutterSize + 'px'} },
                sizes: [17, 17, 17, 49],
                minSize: 150,
                gutterSize: 6,
                cursor: 'col-resize',
                onDragEnd: this.onResize
            });

            this.onResize();
        },
        methods: {
            onResize() {
                // this.width = window.innerWidth * 0.4;
                this.width = document.querySelector('#resize4').offsetWidth * 0.99;
                this.height = window.innerHeight * 0.4;
            },
            changeBot(newBot) {
                this.currentBot = newBot;
                this.$nextTick(function() {
                    // setTimeout(() => {
                        this.$refs.signalsBlock.scrollTop = this.$refs.signalsBlock.scrollHeight;
                        // this.$refs.pairBlock.scrollTop = this.$refs.pairBlock.scrollHeight;
                    // }, 200);
                });

                // this.generateChart();
            },
            changePair(pair) {
                this.currentPair = pair;

                this.$nextTick(function() {
                    // setTimeout(() => {
                    this.$refs.pairBlock.scrollTop = this.$refs.pairBlock.scrollHeight;
                    // }, 200);
                });

                this.generateChart();
            },
            generateChart() {
                this.selectedIntervals.forEach(async (interval) => {
                    this.charts[interval] = await this.getChart(interval);
                });
            },
            async getChart(interval) {
                let chart = {
                    offchart: [
                        {
                            "name": "Время",
                            "type": "Время",
                            "data": [],
                            "settings": {}
                        },
                    ],
                    ohlcv: [],
                    onchart: [
                        {
                            'data': [],
                            'name': "LongShortTrades",
                            'type': "LongShortTrades",
                            'settings': {
                                'labelColor': '#888',
                                'legend': false,
                                'z-index': 5,
                                'showPrevPivots': false
                            }
                        }
                    ],
                };

                const klines = await this.getKlines(interval);
                klines.forEach((kline) => {
                    chart.ohlcv.push([
                        kline[0], // timestamp
                        parseFloat(kline[1]), // open
                        parseFloat(kline[2]), // high
                        parseFloat(kline[3]), // low
                        parseFloat(kline[4]), // close
                        parseFloat(kline[5]),
                    ]);

                    chart.offchart[0].data.push([kline[0], moment.unix(kline[0] / 1000).format('YYYY-MM-DD HH:mm')]);

                    const enabledBotsKeys = this.selectedBots.map((selectedBot) => {return selectedBot.key;});

                    this.pairSignals.forEach((signal) => {
                        if (!enabledBotsKeys.includes(signal.bot_key)) { //
                            return;
                        }

                        const signalData = JSON.parse(signal.data);

                        let botSymbol = '🕵';
                        if (signal.bot_key === '2') {
                            botSymbol = '🚀';
                        } else if (signal.bot_key === '3') {
                            botSymbol = '💰';
                        } else if (signal.bot_key === '5') {
                            botSymbol = '💵';
                        }

                        if (signal.service === 'binance') {
                            botSymbol += ' B';
                        } else if (signal.service === 'bybit') {
                            botSymbol += ' By';
                        }

                        // console.log(signalData);
                        const startTime = signalData.start_timestamp ?? (signalData.timestamp ?? signal.timestamp);
                        if (startTime && startTime >= kline[0] && startTime <= kline[6]) {
                            chart.onchart[0].data.push([
                                kline[0],
                                6,
                                botSymbol + (signalData.side ? (signalData.side === 'LONG' ? '🟢' : '🔴') : ''), //
                                signalData.start_price ? String(signalData.start_price) : (signalData.amount ? String(signalData.amount) : ''),
                                parseFloat(kline[1]), // open
                                parseFloat(kline[2]), // high
                                parseFloat(kline[3]), // low
                                parseFloat(kline[4]), // close
                            ]);
                        }

                        const endTime = signalData.end_timestamp;
                        if (endTime && endTime >= kline[0] && endTime <= kline[6]) {
                            chart.onchart[0].data.push([
                                kline[0],
                                4,
                                (signalData.hasOwnProperty('is_up') && !signalData.is_up || signalData.start_price > signalData.end_price ? '-' : '+') + ' ' + botSymbol, //
                                signalData.end_price ? String(signalData.end_price) : (signalData.percent_oi ? String(signalData.percent_oi) + '%' : ''),
                                parseFloat(kline[1]), // open
                                parseFloat(kline[2]), // high
                                parseFloat(kline[3]), // low
                                parseFloat(kline[4]), // close
                            ]);
                        }
                    });
                });

                return chart;
            },
            async toggleChart(interval, isEnabled) {
                if (!isEnabled) {
                    return;
                }

                if (this.currentPair) {
                    this.charts[interval] = await this.getChart(interval);
                }
            },
            getKlines(interval) {
                return axios.get('https://fapi.binance.com/fapi/v1/klines',{
                    params: {
                        symbol: this.currentPair,
                        interval: interval,
                        limit: 1000
                    }
                }, {withCredentials: true})
                    .then((result) => {
                        // console.log(result);
                        return result.data;
                    })
                    .catch(e => {
                        if(e.response && e.response.data && e.response.data.errors){
                            alert(e.response.data.errors);
                        }
                        return [];
                    });
            },
            changeKlineInterval(event) {
                this.currentKlineInterval = event.target.value;
                this.generateChart();
            },
            searchPairs(input) {
                if (input.length < 1) {
                    this.filterPair = '';
                    return this.currentPairs;
                }
                return this.currentPairs.filter(pair => {
                    return pair.toLowerCase()
                        .startsWith(input.toLowerCase())
                })
            },
            onSubmitPair(input) {
                this.filterPair = input;
            }
        },
    }
</script>
